import React from "react";
import styled from "@emotion/styled";

const ToggleContainer = styled("div")({
  display: "contents",
});

export const ToggleIcon = styled("img")(({ iconWidth }) => ({
  width: iconWidth,
}));

const ToggleLabel = styled("div")({
  fontSize: "12px",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.6px",
  color: "var(--text-color-accent)",
  marginBottom: "0",
  display: "flex",
  alignItems: "center",
});

const Switch = styled("label")({
  position: "relative",
  display: "inline-block",
  width: "38px",
  height: "20px",
  input: {
    opacity: 0,
    width: 0,
    height: 0,
  },
  span: {
    position: "absolute",
    cursor: "pointer",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "var(--accordian-border)",
    transition: ".4s",
    borderRadius: "20px",
    "&:before": {
      position: "absolute",
      content: '""',
      height: "16px",
      width: "16px",
      left: "2px",
      bottom: "2px",
      backgroundColor: "white",
      transition: ".4s",
      borderRadius: "50%",
    },
  },
  "input:checked + span": {
    backgroundColor: "#6860EE",
  },
  "input:focus + span": {
    boxShadow: "0 0 1px #6860EE",
  },
  "input:checked + span:before": {
    transform: "translateX(18px)",
  },
});

const ToggleLabelAndSwitcher = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "10px",
  padding: "10px 0"
});

function ToggleSwitcher({
  icon,
  label,
  name,
  value,
  onChange,
  labelStyle = {},
  highlightText,
  highlightTextStyle = {},
  required = false
}) {
  return (
    <ToggleContainer>
      { icon && (
      <ToggleIcon src={icon} alt="icon"></ToggleIcon>
      )}
      <ToggleLabelAndSwitcher>
      <ToggleLabel style={labelStyle}>
        {label} <span style={highlightTextStyle}>{highlightText}</span>{required && (<span style={{color: "red", fontSize: "16px"}}>*</span>)}
      </ToggleLabel>
      <Switch>
        <input
          type="checkbox"
          name={name}
          checked={value}
          onChange={(e) => onChange(name, e.target.checked)}
        />
        <span className="slider round"></span>
      </Switch>
      </ToggleLabelAndSwitcher>
    </ToggleContainer>
  );
}

export default ToggleSwitcher;
